import { SocketIoConfig } from "ngx-socket-io";
import { environment } from "../../environments/environment";

export const KatchaSocketConfig: SocketIoConfig = {
    url: environment.socketUrl,
    options: {
        autoConnect: false,
        reconnection: true,
        transports: ['websocket'],
    }
}